/**
 * @Author: Fannie
 * @Date:   2018-04-25T08:55:02+08:00
 * @Last modified by:

 * @Last modified time: 2018-04-25T08:55:02+08:00
 */

import _util from '../../utils/';

const myAttendance = {
    fetchMyAttendanceList (params, resolve, reject) {
        _util.request({
            url: '/api/MyAttendance/MyAttendanceRecords',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchLeaveRecords (params, resolve, reject) {
        _util.request({
            url: '/api/MyAttendance/LeaveRecords',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchOvertimeRecords (params, resolve, reject) {
        _util.request({
            url: '/api/MyAttendance/OvertimeRecords',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchMyAttendanceRecords (params, resolve, reject) {
        _util.request({
            url: '/api/MyAttendance/MyAttendance',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchMyAttendanceDetail(gets, resolve, reject) {
        _util.request({
            url: '/api/MyAttendance/MyAttendanceDetails',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    fetchAttendanceComplaint(posts, resolve, reject) {
        _util.request({
            url: '/api/HRApprovalAttendanceComplaint/Post',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        });
    },
    fetchBreakdownAttendance (gets, resolve, reject) {
        _util.request({
            url: '/api/MyAttendance/RelaxationRecords',
            params: gets,
            success: resolve,
            error: reject
        })
    },
}


export default myAttendance;


// WEBPACK FOOTER //
// ./src/services/Employee/my-attendance-service.js